import '@bp/frontend/startup';
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';

import { TelemetryService } from '@bp/frontend/services/telemetry';

/**
 * We bootstrap app in next event loop because we have microtasks `bpQueueMicrotask` we need to finish
 * executing before running main app
 */
setTimeout(async () => {
	// Features set their `actions` in a `bpQueueMicrotask` and the app routes read them as soon as they are imported,
	// so the features are created first and the app is imported once those microtasks have run
	await import('@bp/shared/domains/permissions');

	const app = await import('@bp/apps/merchant-admin-v3-frontend');

	void bootstrapApplication(app.RootComponent, {
		providers: [
			provideAnimations(),
			provideZoneChangeDetection({
				ignoreChangesOutsideZone: true,
				eventCoalescing: true,
				runCoalescing: true,
			}),
			importProvidersFrom(app.AppModule),
		],
	})
		.catch(TelemetryService.appErrorHandler);
});
